import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const ValueGrid = ({
  spacing = 0, 
  titleProps = {
    variant: 'body1',
  },
  valueProps = {
    variant: 'body1',
  },
  theme = {},
  titleSize = 4,
  data = [],
  raw = false,
}) => {

  return (
    <Grid container spacing={ spacing }>
      {
        data.map((item, i) => {
          return (
            <React.Fragment key={ i }>
              <Grid item xs={ titleSize }>
                {
                  raw ? item.title : (
                    <Typography className={ theme.title } { ...titleProps }>
                      { item.title }
                    </Typography>
                  )
                }
              </Grid>
              <Grid item xs={ 12 - titleSize }>
                {
                  raw ? item.value : (
                    <Typography className={ theme.value } { ...valueProps }>
                      { item.value }
                    </Typography>
                  )
                }
              </Grid>
            </React.Fragment>
          )
        })
      }
    </Grid>
  )
}

export default ValueGrid